<template>
  <main-template>
    <v-row>
      <v-col>
        <h2>
          <v-btn color="primary" x-small text @click="$router.back()">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          DESEMPENHO PEDAGÓGICO - COORDENADOR
          <span class="meu-componente-especial">
            <e-help-tooltip
              :text="$constants.tooltips.desempenhoPedagogico.desempenhoCoordenador"
            />
          </span>
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          prepend-icon="mdi-school"
          v-model="escola"
          :items="franquias.filter((item) => !item.deleted_at)"
          item-text="descricao"
          item-value="id"
          dense
          return-object
          filled
          color="orange"
          label="Selecione uma escola"
          @change="onEscolaChange"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row v-if="carregandoUsabilidade">
      <v-col cols="12">
        <div class="text-center mb-4">
          <v-icon color="primary" class="mb-2">mdi-loading mdi-spin</v-icon>
          <p class="text-body-2 text-medium-emphasis">Aguarde, isso pode demorar...</p>
        </div>

        <v-card class="mb-3" v-for="n in 3" :key="n" elevation="1">
          <v-card-text>
            <div class="d-flex align-center mb-3">
              <v-skeleton-loader type="avatar" class="me-3"></v-skeleton-loader>

              <div class="flex-grow-1">
                <v-skeleton-loader type="heading" class="mb-1" width="60%"></v-skeleton-loader>
                <v-skeleton-loader type="subtitle" width="40%"></v-skeleton-loader>
              </div>

              <v-skeleton-loader type="chip" width="80px"></v-skeleton-loader>
            </div>

            <v-skeleton-loader type="paragraph" class="mb-2"></v-skeleton-loader>

            <div class="d-flex justify-end gap-2">
              <v-skeleton-loader type="button" width="80px"></v-skeleton-loader>
              <v-skeleton-loader type="button" width="100px"></v-skeleton-loader>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else-if="turmasAgrupadas.length === 0">
      <v-col cols="12">
        <v-alert type="info" text>
          Nenhum dado de desempenho encontrado para a escola selecionada.
        </v-alert>
      </v-col>
    </v-row>

    <div v-else>
      <!-- SEÇÃO COORDENADORES RESPONSÁVEIS MELHORADA -->
      <v-col cols="12 mb-8">
        <v-card class="coordenadores-card" elevation="2">
          <v-card-text class="pa-4">
            <div class="d-flex align-center mb-2">
              <v-icon color="primary" class="me-2">mdi-account-tie</v-icon>
              <h3 class="mb-0 text-h6 font-weight-medium">{{ tituloCoordenadores }}</h3>
            </div>

            <div v-if="carregandoCoordenadores" class="d-flex align-center">
              <v-progress-circular
                indeterminate
                size="20"
                width="2"
                color="primary"
                class="me-3"
              ></v-progress-circular>
              <span class="text-body-2 text-medium-emphasis">Carregando coordenadores...</span>
            </div>

            <div v-else-if="coordenadoresResponsaveisList.length === 0" class="text-center py-3">
              <v-icon color="grey lighten-1" class="mb-2" size="40">mdi-account-off-outline</v-icon>
              <p class="text-body-2 text-medium-emphasis mb-0">
                Nenhum coordenador responsável encontrado
              </p>
            </div>

            <div v-else class="coordenadores-list">
              <div
                v-for="(coordenador, index) in coordenadoresResponsaveisList"
                :key="coordenador.id"
                class="coordenador-item d-flex align-center py-2"
                :class="{ 'border-bottom': index < coordenadoresResponsaveisList.length - 1 }"
              >
                <v-avatar size="36" color="primary" class="me-3">
                  <span class="white--text text-caption font-weight-bold">
                    {{ coordenador.name.charAt(0).toUpperCase() }}
                  </span>
                </v-avatar>

                <div class="flex-grow-1">
                  <div class="text-body-1 font-weight-medium">{{ coordenador.name }}</div>
                  <div class="text-caption text-medium-emphasis">
                    <ul>
                      <li>
                        Modalidade de Ensino:
                        {{
                          coordenador.cursos.length > 0
                            ? coordenador.cursos.map((curso) => curso.descricao).join(", ")
                            : "N/A"
                        }}
                      </li>
                    </ul>
                  </div>
                </div>
                <v-chip small color="primary" text-color="white" class="ms-2"> Coordenador </v-chip>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
        <v-tab href="#professores">
          <v-icon left>groups</v-icon>
          Desempenho dos Coordenadores
        </v-tab>
        <v-tab href="#relatorios">
          <v-icon left>query_stats</v-icon>
          Relatórios de Desempenho (Coordenador)
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="mt-4">
        <v-tab-item value="professores">
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-title>
                  <span class="text-h6">Turmas:</span>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar Turma"
                    single-line
                    hide-details
                    dense
                    class="ml-4 mt-6 mr-6 mb-3"
                    style="max-width: 350px"
                  >
                  </v-text-field>
                </v-card-title>

                <!-- Lista de turmas -->
                <v-card-text>
                  <v-expansion-panels>
                    <turma-expansion-item
                      v-for="turma in turmasPaginadas"
                      :key="turma.id"
                      :turma="turma"
                      class="mb-4 gestao-card"
                    />
                  </v-expansion-panels>
                </v-card-text>

                <e-paginate
                  v-if="totalPages > 1"
                  :current_page="currentPage"
                  :last_page="totalPages"
                  :page-number="currentPage"
                  :search="searchTerm"
                  @changeActionResponse="handlePageChange"
                  class="mt-4 mb-4 pagination-fix"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item value="relatorios">
          <v-card>
            <v-card-text class="d-flex justify-start align-center flex-wrap">
              <v-col cols="12" sm="6" md="4">
                <v-card color="primary" @click="DesempenhoCoordenadorPorFranquia(escola?.id)">
                  <v-card-title>
                    <v-icon large left> groups </v-icon>
                    <span class="title font-weight-light">Relatorio Desempenho</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold">por Unidade Escolar</v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-card color="primary" @click="DesempenhoCoordenadorPorTurma(escola?.id)">
                  <v-card-title>
                    <v-icon large left> groups </v-icon>
                    <span class="title font-weight-light">Relatorio Desempenho</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold">por Turma</v-card-text>
                </v-card>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <e-modal-turmas-franquia
      :dialog="dialogTurmasFranquia"
      :franquia_id="escola?.id"
      @dialogChange="dialogTurmasFranquia = $event"
      tipo-relatorio="coordenador"
    ></e-modal-turmas-franquia>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import EPaginate from "@/components/EPaginate.vue";
import TurmaExpansionItem from "./CoordenadorExpansionItem.vue";

export default {
  components: {
    TurmaExpansionItem,
    EPaginate,
  },

  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquiasList"]),

    turmasAgrupadas() {
      if (!this.UsabilidadeList || !this.UsabilidadeList.turmas) {
        return [];
      }

      const turmasMap = new Map();

      this.UsabilidadeList.turmas.forEach((turma) => {
        if (!turmasMap.has(turma.id)) {
          turmasMap.set(turma.id, {
            id: turma.id,
            nome: turma.descricao,
            gestoes: [],
          });
        }

        const turmaAtual = turmasMap.get(turma.id);

        turma.professores.forEach((professor) => {
          professor.gestoes.forEach((gestao) => {
            turmaAtual.gestoes.push({
              id: gestao.id,
              professor_nome: professor.nome,
              curso_id: turma.curso_id,
              turma: turma.descricao,
              disciplina_id: gestao.disciplina_id,
              disciplinas_da_gestao: gestao.disciplinas_da_gestao,
              relacaoAulasEtapas: gestao.relacaoAulasEtapas,
              pendencias: gestao.pendencias,
              turma_id: turma.id,
              instrutor_id: gestao.instrutor_id,
              is_polivalencia: gestao.is_polivalencia,
              series_da_turma: turma.series_da_turma.split(",").map((s) => s.trim()),
            });
          });
        });
      });

      return Array.from(turmasMap.values());
    },

    turmasFiltradas() {
      if (!this.search) {
        return this.turmasAgrupadas;
      }
      const searchTerm = this.search.toLowerCase().trim();
      return this.turmasAgrupadas.filter((turma) => turma.nome.toLowerCase().includes(searchTerm));
    },

    totalTurmas() {
      return this.turmasFiltradas.length;
    },

    totalPages() {
      return Math.ceil(this.totalTurmas / this.itemsPerPage);
    },

    turmasPaginadas() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.turmasFiltradas.slice(start, end);
    },

    tituloCoordenadores() {
      const count = this.coordenadoresResponsaveisList.length;
      if (count > 1) {
        return "Coordenadores Responsáveis";
      }
      return "Coordenador Responsável";
    },
  },

  async mounted() {
    await this.loadData();
    if (this.escola.id) {
      await this.loadCoordenadoresResponsaveis(this.escola.id);
      await this.loadPendenciasProfessores(this.escola.id);
    }
  },

  data() {
    return {
      tab: "professores",
      escola: {
        id: null,
        descricao: null,
      },
      UsabilidadeList: [],
      carregandoUsabilidade: false,
      currentPage: 1,
      itemsPerPage: 5,
      search: "",
      searchTerm: "",
      franquias: [],
      podeTrocarFranquia: false,
      dialogTurmasFranquia: false,
      carregandoCoordenadores: false,
      coordenadoresResponsaveisList: [],
    };
  },

  watch: {
    search() {
      this.currentPage = 1;
    },
  },

  methods: {
    async loadData() {
      await this.$services.franquiasService.syncAll();
      this.escola.id = this.user.franquia.id;
      const data1 = this.franquiasList?.map((franq) => {
        if (!this.user.franquias_permitidas) {
          this.franquias = [...this.franquiasList];
        }
        const data2 = this.user.franquias_permitidas?.map((franquiaPermitida) => {
          if (franquiaPermitida === franq.id) {
            this.franquias.push(franq);
          }
        });
      });
    },

    async loadPendenciasProfessores(escolaId) {
      if (!escolaId) return;

      this.carregandoUsabilidade = true;
      try {
        const response = await this.$services.usabilidadeService.getCoordenadorUsabilidade(
          escolaId
        );
        this.UsabilidadeList = response;
        this.currentPage = 1;
        this.search = "";
      } catch (error) {
        this.UsabilidadeList = [];
        this.$handleError(error);
      } finally {
        this.carregandoUsabilidade = false;
      }
    },

    handlePageChange(page, searchTerm) {
      this.currentPage = page;
      this.searchTerm = searchTerm;
    },

    async DesempenhoCoordenadorPorFranquia(escolaId) {
      this.$loaderService.open("Carregando dados... Isso pode demorar um pouco.");
      await this.$services.relatoriosService.DesempenhoCoordenadorPorFranquia(escolaId);
      this.$loaderService.close();
    },

    async DesempenhoCoordenadorPorTurma(escolaId) {
      try {
        this.franquia_id = escolaId;
        this.dialogTurmasFranquia = !this.dialogTurmasFranquia;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async onEscolaChange() {
      if (this.escola && this.escola.id) {
        // Carrega coordenadores e depois as pendências
        await this.loadCoordenadoresResponsaveis(this.escola.id);
        await this.loadPendenciasProfessores(this.escola.id);
      } else {
        this.coordenadoresResponsaveisList = [];
        this.UsabilidadeList = [];
      }
    },

    async loadCoordenadoresResponsaveis(escolaId) {
      if (!escolaId) {
        this.coordenadoresResponsaveisList = [];
        return;
      }

      try {
        this.carregandoCoordenadores = true;
        const response = await this.$services.usuariosService.coordenadoresResponsaveisList(
          escolaId
        );
        this.coordenadoresResponsaveisList = response || [];
      } catch (error) {
        this.$handleError(error);
        this.coordenadoresResponsaveisList = [];
      } finally {
        this.carregandoCoordenadores = false;
      }
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  min-height: 48px;
}

.v-card {
  height: 100%;
  transition: all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 8px !important;
  overflow: hidden;
  border-left: 4px solid transparent;
}

.v-card.primary {
  border-left-color: var(--v-primary-base);
  background: linear-gradient(to right, #fff7e4, #ffffff);
}

.v-card.success {
  border-left-color: var(--v-success-base);
  background: linear-gradient(to right, #f0fff0, #ffffff);
}

.v-tabs {
  border-radius: 8px;
}

.v-tab {
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.v-tab--active {
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.062);
}

.v-tab-item {
  padding: 8px 0;
}

.v-col {
  padding-bottom: 16px;
  padding-top: 8px;
}

@media (max-width: 960px) {
  .v-card__title {
    font-size: 1rem !important;
    padding: 12px !important;
  }

  .v-card__text {
    font-size: 0.875rem !important;
    padding: 0 12px 12px !important;
  }

  .v-tab {
    font-size: 0.75rem;
    min-width: auto;
    padding: 0 12px;
  }

  .v-tab .v-icon {
    font-size: 1.25rem !important;
    margin-right: 4px !important;
  }
}

.v-card:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.3s;
}

.v-card:hover:before {
  opacity: 0.04;
}

.v-autocomplete {
  border-radius: 8px;
  overflow: hidden;
}

.v-row:not(:last-child) {
  margin-bottom: 16px;
}

.pagination-fix {
  position: relative;
  z-index: 1;
}

/* ESTILOS ESPECÍFICOS PARA A SEÇÃO DE COORDENADORES */
.coordenadores-card {
  border-left: 4px solid #2196f3 !important;
  background: linear-gradient(to right, #f8fdff, #ffffff);
}

.coordenadores-list {
  max-height: 300px;
  overflow-y: auto;
}

.coordenador-item {
  transition: background-color 0.3s ease;
}

.coordenador-item:hover {
  background-color: #f5f5f5;
  border-radius: 6px;
}

.border-bottom {
  border-bottom: 1px solid #e0e0e0;
}

.coordenadores-card .v-card__text {
  padding: 20px;
}

/* Scrollbar personalizada para a lista de coordenadores */
.coordenadores-list::-webkit-scrollbar {
  width: 6px;
}

.coordenadores-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.coordenadores-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.coordenadores-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
